// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import {vueAxios} from '@/plugins/axios'
import lodash from '@/plugins/lodash'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import PopupVue from './globalComponent/popup/popup'
import {initSdk} from './plugins/redcatSdk'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import upload from '@/plugins/upload'
import uuid from './plugins/uuid'
import theme from '@/plugins/theme/theme'
// 挂载全局指令
import './directives/index'
import toolTipComponent from 'echarts/lib/component/tooltip'

Vue.config.productionTip = false

// 给全局注册 redcatApp
if (!window.redcatApp) window.redcatApp = {}

Vue.use(vueAxios)
Vue.use(lodash)
Vue.use(ElementUI, {size: 'mini'})
Vue.use(PopupVue)
Vue.use(uuid)
Vue.use(VueAwesomeSwiper)
Vue.use(upload)
Vue.use(theme)
Vue.use(toolTipComponent)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  created () {
    initSdk(this)
  }
})



// WEBPACK FOOTER //
// ./src/main.js